var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,17.8l-1.4-1.4c-1.3,0.3-2.7,0.4-4,0.4c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c0,0,0,0-0.1-0.1 c-0.9-0.9-1.7-1.9-2.5-3c-0.7-1.1-1.4-2.3-1.9-3.4c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1C7,8.6,7.6,7.4,8.4,6.3 L7.6,4.5L6.7,2.2L5.9,0.4C5.5,0.5,5.1,0.6,4.7,0.8C4,1,3.3,1.4,2.6,1.8C2.2,2.1,1.9,2.4,1.7,2.7C1.5,3,1.4,3.3,1.3,3.6 c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.7-0.1,1.4,0,2C1.8,9,3,12.1,4.8,15c0.2,0.2,0.3,0.5,0.5,0.7c0.2,0.2,0.3,0.5,0.5,0.7 c2,2.7,4.3,5,7,6.7c0.6,0.4,1.2,0.6,1.9,0.8c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0c0.4-0.1,0.8-0.2,1.2-0.5c0.7-0.4,1.3-1,1.8-1.5 c0.3-0.3,0.5-0.6,0.8-1l-1.4-1.4L16.5,17.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,5.4c-1.9-2.8-4.7-4.7-8-5.3c-0.4-0.1-0.8,0.2-0.9,0.6C11.8,1,12,1.4,12.4,1.5c2.9,0.6,5.4,2.3,7.1,4.7 c1.6,2.5,2.2,5.4,1.7,8.3c-0.1,0.4,0.2,0.8,0.6,0.9c0,0,0.1,0,0.1,0c0.3,0,0.7-0.2,0.7-0.6C23.3,11.5,22.6,8.2,20.7,5.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,5.7c1.8,0.3,3.3,1.4,4.3,2.9c1,1.5,1.4,3.3,1,5.1c-0.1,0.4,0.2,0.8,0.6,0.9c0,0,0.1,0,0.1,0 c0.3,0,0.7-0.2,0.7-0.6c0.4-2.2,0-4.4-1.2-6.2c-1.2-1.8-3.1-3.1-5.2-3.5c-0.4-0.1-0.8,0.2-0.9,0.6C10.9,5.3,11.2,5.7,11.6,5.7z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.33c9859b.svg";
export { ForwardRef as ReactComponent };